import React from "react"
import { createPortal } from "react-dom"
import { Snackbar, Fade } from "@material-ui/core"
import MuiAlert from "@material-ui/lab/Alert"

const FadeTransition = props => <Fade {...props} />
const Alert = props => <MuiAlert elevation={6} variant="filled" {...props} />

export default function Notification({ title, type }) {
  return createPortal(
		<>
      {title && (
        <Snackbar 
          open={title.length > 0} 
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          TransitionComponent={FadeTransition}
        >
          <Alert severity={type}>
            {title}
          </Alert>
        </Snackbar>
      )}
    </>,
		document.getElementById("portalRoot")
	)
}
